import { render, staticRenderFns } from "./vertical-stripped.vue?vue&type=template&id=cff93dd4&"
import script from "./vertical-stripped.vue?vue&type=script&lang=js&"
export * from "./vertical-stripped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports